<template>
  <v-img
    v-if="badgeResp.src"
    :aspect-ratio="aspectRatio"
    :sizes="badgeResp.sizes"
    :src="badgeResp.src"
    :srcset="badgeResp.srcset"
    :alt="value.alt_text || 'Badge for product'"
    contain
    max-height="130"
    max-width="130"
  />
</template>

<script setup>
import { toRef } from 'vue'
import { useImgResponsive } from '#root/lib/img'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 1
const badgeResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      xs: '200px'
    }
  }))
)
</script>
